(function () {
  function restoreProductNavigation() {
    var desktopNav = document.querySelector('.mh-site-menu, .mh-site-nav');
    if (desktopNav && !desktopNav.querySelector('.mh-site-nav__dropdown')) {
      desktopNav.className = 'mh-site-nav';
      desktopNav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><details class="mh-site-nav__dropdown"><summary>Products</summary><div><a href="/pages/electrical-steel-products">Product Overview</a><a href="/pages/mother-coil">Mother Coil</a><a href="/pages/slitting-coil">Slitting Coil</a><a href="/pages/lamination">Lamination</a><a href="/pages/transformer-core">Transformer Core</a></div></details><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    }
    var mobileNav = document.querySelector('.mh-site-mobile__panel');
    if (mobileNav && !mobileNav.querySelector('a[href="/pages/mother-coil"]')) {
      mobileNav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/electrical-steel-products">Product Overview</a><a href="/pages/mother-coil">Mother Coil</a><a href="/pages/slitting-coil">Slitting Coil</a><a href="/pages/lamination">Lamination</a><a href="/pages/transformer-core">Transformer Core</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    }
  }
  restoreProductNavigation();
  document.addEventListener('DOMContentLoaded', restoreProductNavigation);
  window.addEventListener('load', restoreProductNavigation);
  setTimeout(restoreProductNavigation, 500);
  setTimeout(restoreProductNavigation, 1500);
  setTimeout(restoreProductNavigation, 3000);
})();
